import { AssetChip, Avatar } from '@flex-design-system/fx';
import {
  DocumentIcon,
  ExcelDocumentIcon,
  PdfDocumentIcon,
  WordDocumentIcon,
} from '@flex-design-system/fx-icons';
import type { ComponentProps } from 'react';

import {
  getCandidateAttachmentFileType,
  type CandidateAttachmentFileType,
} from '../../../base';

type AvatarColor = ComponentProps<typeof Avatar>['color'];

interface FileTypeStyle {
  Icon: typeof PdfDocumentIcon;
  avatarColor: AvatarColor;
}

const FILE_TYPE_STYLE: Record<CandidateAttachmentFileType, FileTypeStyle> = {
  pdf: { Icon: PdfDocumentIcon, avatarColor: 'presetOrange' },
  word: { Icon: WordDocumentIcon, avatarColor: 'presetBlueGray' },
  excel: { Icon: ExcelDocumentIcon, avatarColor: 'presetGreen' },
  unknown: { Icon: DocumentIcon, avatarColor: 'presetGray' },
};

interface FileInfo {
  fileName?: string;
  mimeType?: string;
}

interface AvatarProps extends FileInfo {
  size?: ComponentProps<typeof Avatar>['size'];
}

export const CandidateAttachmentFileAvatar = ({
  fileName,
  mimeType,
  size = 'xsmall',
}: AvatarProps) => {
  const fileType = getCandidateAttachmentFileType({ fileName, mimeType });
  const { Icon, avatarColor } = FILE_TYPE_STYLE[fileType];

  return (
    <Avatar size={size} color={avatarColor}>
      <Icon type="solid" color="white" size={16} />
    </Avatar>
  );
};

interface AssetChipProps extends FileInfo {
  size?: ComponentProps<typeof AssetChip.ThumbnailAvatar>['size'];
}

export const CandidateAttachmentFileAssetChip = ({
  fileName,
  mimeType,
  size,
}: AssetChipProps) => {
  const fileType = getCandidateAttachmentFileType({ fileName, mimeType });
  const { Icon, avatarColor } = FILE_TYPE_STYLE[fileType];

  return (
    <AssetChip.ThumbnailAvatar size={size} color={avatarColor}>
      <Icon type="solid" color="white" size={16} />
    </AssetChip.ThumbnailAvatar>
  );
};
